import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import L from "leaflet";
import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { CATEGORIES } from "../lib/categories";

const CHAD_CENTER = [12.1348, 15.0557];

function buildIcon(color, highlighted) {
  const size = highlighted ? 38 : 32;
  return L.divIcon({
    className: "",
    html: `<div style="
      background:${color};
      border:3px solid #FFFFFF;
      border-radius:50% 50% 50% 0;
      transform:rotate(-45deg) ${highlighted ? "scale(1.1)" : ""};
      width:${size}px;
      height:${size}px;
      box-shadow:0 4px 12px rgba(45,42,38,0.25);
    "></div>`,
    iconSize: [size, size],
    iconAnchor: [size / 2, size],
    popupAnchor: [0, -size + 4],
  });
}

export default function MapView({ places, highlightedId, center, zoom = 6, autoFit = true }) {
  const mapRef = useRef(null);

  useEffect(() => {
    if (autoFit && mapRef.current && places && places.length > 0) {
      try {
        const bounds = L.latLngBounds(places.map((r) => [r.lat, r.lng]));
        if (bounds.isValid()) {
          mapRef.current.fitBounds(bounds, { padding: [40, 40], maxZoom: 13 });
        }
      } catch {}
    }
  }, [places, autoFit]);

  return (
    <div className="w-full h-full rounded-2xl overflow-hidden border border-brand-line shadow-[0_8px_32px_rgba(45,42,38,0.04)]" data-testid="map-container">
      <MapContainer
        center={center || CHAD_CENTER}
        zoom={zoom}
        scrollWheelZoom
        ref={mapRef}
        className="w-full h-full"
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {places?.map((p) => {
          const cat = CATEGORIES[p.category] || CATEGORIES.restaurant;
          return (
            <Marker
              key={p.id}
              position={[p.lat, p.lng]}
              icon={buildIcon(cat.color, p.id === highlightedId)}
            >
              <Popup>
                <div className="font-body min-w-[200px]">
                  <div
                    className="text-[10px] uppercase tracking-[0.18em] font-bold mb-1"
                    style={{ color: cat.color }}
                  >
                    {cat.singular}
                  </div>
                  <div className="font-heading font-semibold text-brand-ink text-base mb-1.5 leading-tight">
                    {p.name}
                  </div>
                  <div className="text-xs text-brand-inkSoft mb-2">
                    {p.city} {p.price_range ? `· ${p.price_range}` : ""}
                  </div>
                  <Link
                    to={`/place/${p.id}`}
                    className="text-xs font-semibold text-brand-terracotta hover:underline"
                  >
                    Voir les détails →
                  </Link>
                </div>
              </Popup>
            </Marker>
          );
        })}
      </MapContainer>
    </div>
  );
}
